// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__u29hP {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 150px;
}

.styles_formRoot__\\+sU0B {
  justify-self: end;
  align-self: flex-end;
  align-items: center;
  flex-direction: row;
  width: auto;
  display: flex;
  margin-top: auto;
}

.styles_submitItem__Fc4Q4 {
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center !important;
  margin: 1em 0;
  margin-right: auto;
  padding: 6px 24px;
  min-width: 118px;
  height: 36px;
  color: #ffffff;
  border-radius: 4px;
  margin-top: auto;
  line-height: 20px;
}

.styles_submitItem__Fc4Q4 span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

.styles_closeItem__EYam4 {
  margin: 0 5px;
  margin: 1em 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center !important;
  padding: 6px 24px;
  width: 118px;
  height: 36px;
  left: 343px;
  top: 348px;
  background: #ffffff;
  border-radius: 4px;
  margin-top: auto;
  line-height: 20px;
  margin-right: 5px;
}

.styles_closeItem__EYam4 span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

.styles_lds_ring__Nf6nA {
  height: 12px;
  width: 12px;
}

.styles_lds_ring__Nf6nA div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  animation: styles_lds_ring__Nf6nA 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #ffffff transparent transparent transparent;
}

.styles_lds_ring__Nf6nA div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__Nf6nA div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__Nf6nA div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__Nf6nA {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 800px) {
  .styles_container__u29hP {
    align-items: normal;
    width: 100%;
    max-width: 100%;
  }
  .styles_formRoot__\\+sU0B {
    align-self: auto;
    margin-top: 42px;
  }
  .styles_submitItem__Fc4Q4 {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Form/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;AACF;;AACA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAEF;;AAAA;EAEE,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EAEA,cAAA;EAEA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AADF;;AAIA;EAEE,aAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EAEA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,iBAAA;AAJF;;AAOA;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AALF;;AAUA;EAEE,YAAA;EACA,WAAA;AARF;;AAWA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AATF;;AAYA;EACE,uBAAA;AATF;;AAYA;EACE,sBAAA;AATF;;AAYA;EACE,uBAAA;AATF;;AAYA;EACE;IACE,uBAAA;EATF;EAYA;IACE,yBAAA;EAVF;AACF;AAaA;EACE;IACE,mBAAA;IACA,WAAA;IACA,eAAA;EAXF;EAcA;IACE,gBAAA;IACA,gBAAA;EAZF;EAcA;IACE,WAAA;EAZF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  min-height: 150px;\n}\n.formRoot {\n  justify-self: end;\n  align-self: flex-end;\n  align-items: center;\n  flex-direction: row;\n  width: auto;\n  display: flex;\n  margin-top: auto;\n}\n.submitItem {\n  // justify-self: flex-end;\n  margin: 0 5px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center !important;\n  margin: 1em 0;\n  margin-right: auto;\n  padding: 6px 24px;\n  min-width: 118px;\n  height: 36px;\n\n  color: #ffffff;\n  // background: #e30813;\n  border-radius: 4px;\n  margin-top: auto;\n  line-height: 20px;\n}\n\n.submitItem span {\n  // color: #e30813 !important;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n}\n\n.closeItem {\n  // justify-self: flex-end;\n  margin: 0 5px;\n  margin: 1em 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center !important;\n  padding: 6px 24px;\n  width: 118px;\n  height: 36px;\n  left: 343px;\n  top: 348px;\n  // color: #e30813;\n  background: #ffffff;\n  border-radius: 4px;\n  margin-top: auto;\n  line-height: 20px;\n  // border: 1px solid #e30813;\n  margin-right: 5px;\n}\n\n.closeItem span {\n  // color: #e30813 !important;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n}\n\n//------------------------loader style\n\n.lds_ring {\n  // height: 40px;\n  height: 12px;\n  width: 12px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  // margin: 8px;\n  border: 1px solid #ffffff;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #ffffff transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .container {\n    align-items: normal;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .formRoot {\n    align-self: auto;\n    margin-top: 42px;\n  }\n  .submitItem {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__u29hP`,
	"formRoot": `styles_formRoot__+sU0B`,
	"submitItem": `styles_submitItem__Fc4Q4`,
	"closeItem": `styles_closeItem__EYam4`,
	"lds_ring": `styles_lds_ring__Nf6nA`
};
export default ___CSS_LOADER_EXPORT___;
